import qr from "query-string";
import { useQuery } from "@tanstack/react-query";
import { ClientEntity } from "../types/ClientEntity";
import { fetcher, Pagination, PaginationResponse } from "@/shared/core-configs";
import { API } from "@/config";

export const GET_CLIENT_ENTITIES_FETCH_KEY = "GET_CLIENT_ENTITIES";

type GetClientEntitiesParams = {
  zoneIds?: string[] | string;
  showDisabled?: boolean;
  searchTerm?: string;
  sort?: string;
  order?: string;
} & Partial<Pagination>;

export const getClientEntities = async (
  zoneIds?: string[] | string,
  page?: number,
  pageSize?: number,
  showDisabled = false,
  searchTerm?: string,
  sort?: string,
  order?: string,
): Promise<PaginationResponse<ClientEntity>> => {
  const params = qr.stringify({
    zoneIds,
    pageSize,
    page,
    showDisabled,
    searchTerm,
    sort,
    order,
  });
  const response = await fetcher.get(`${API.GESLUB}/client-entities?${params}`);
  return response.data;
};

export const useGetClientEntities = ({
  zoneIds,
  page,
  pageSize,
  showDisabled,
  searchTerm,
  sort,
  order,
}: GetClientEntitiesParams = {}) => {
  const { data, error, isPending, refetch } = useQuery<
    PaginationResponse<ClientEntity>,
    Error
  >({
    queryKey: [
      GET_CLIENT_ENTITIES_FETCH_KEY,
      zoneIds,
      page,
      pageSize,
      showDisabled,
      searchTerm,
      sort,
      order,
    ],
    queryFn: () =>
      getClientEntities(
        zoneIds,
        page,
        pageSize,
        showDisabled,
        searchTerm,
        sort,
        order,
      ),
    placeholderData: (prev) => prev,
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination,
    error,
    isPending,
    refetch,
  };
};
